import { z } from '@simplisafe/ewok'

export const scriptStatusSchema = z.enum(['error', 'loading', 'ready'])
